<div 
  *ngIf="showOverlay"  
  class="overlay-empty overlay rounded position-absolute top-0 bottom-0 d-flex justify-content-center align-items-center flex-column w-100" >
  <i *ngIf="withIcon" [class]="iconClass" class="empty-overlay-icon"></i>
  <img *ngIf="withEmptyImage" class="image" src="/assets/img/backgrounds/empty-box.png" alt="Coming Soon Image">
  <h6 *ngIf="MainText" class="fw-bolder fa-lg m-3 empty-overlay-main-text" [ngClass]="mainTextClass">{{MainText}}</h6>
  <span class="empty-overlay-sub-text">{{SubText}}</span>
</div>